/**
 * Who is working.
 *
 * Exclusions are an audit trail, so every one of them is attributed. The name is
 * remembered in the browser rather than asked for on each action; there is no
 * authentication in front of the app yet, so this is a record of intent, not an
 * identity claim.
 */

const KEY = "evaluwhale.user";

export function getUser() {
  try {
    return window.localStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export function setUser(name) {
  try {
    window.localStorage.setItem(KEY, name || "");
  } catch {
    /* private browsing; the name simply is not remembered */
  }
}
